<script>
import { mapGetters } from 'vuex'
import Roles from '@/mixins/Roles'
export default {
    name: 'ZoneView',

    mixins: [Roles],

    computed: mapGetters({ zone: 'zone' }),

    watch: {
        $route: 'fetch',
    },

    mounted() {
        this.fetch()
    },

    methods: {
        fetch() {
            this.$store.dispatch('zonesFetch', this.$route.params.zone)
        },

        save() {
            this.$store.dispatch('zonesModify', this.zone)
        },
    },
}
</script>

<template lang="pug">
div(v-if="zone && zone.id")
    acrm-top-panel.p-3
        .row
            .col
                .row
                    .col-auto.flex-center-v.align-content-center.justify-content-center
                        acrm-avatar(large :name="zone.name")
                    .col-auto.flex-center-v
                        acrm-heading(:level="2").mb-0 {{ zone.name }}
                    .col-24.col-lg

            .col-auto
                .text-right
                    acrm-input-button-dropdown(variant="link" icon="more_horiz" no-handle large align-right)


    acrm-tabs(:key="`zone-${zone.id}`")
        acrm-tab(:name="$t('ZONES.BASEDATA')" tabKey="base-data")
            acrm-panel
                .row
                    .col-md-12
                        acrm-hidden-input.mb-3(v-model="zone.name" @save="save")
                            label {{ $t('ZONES.NAME')}}
                            div {{ zone.name }}
                            acrm-input-line.mb-1(slot="edit" :disabled="false" v-model="zone.name") {{ $t('ZONES.NAME')}}
                        acrm-hidden-input.mb-3(v-model="zone.is_active" @save="save")
                            label {{ $t('ZONES.IS_ACTIVE')}}
                            div {{ zone.is_active ? $t('BASE.YES') : $t('BASE.NO') }}
                            acrm-input-checkbox.mb-1(slot="edit" :disabled="false" v-model="zone.is_active") {{ $t('ZONES.IS_ACTIVE')}}

        acrm-tab(:name="$t('ZONES.MAPDATA')" tabKey="map-data")
            acrm-panel
                acrm-input-google-map-area(v-model="zone.area" @save="save")
</template>
